import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-report-status-cell',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="status-pill" [ngClass]="statusClass">
      {{ status }}
    </div>
  `,
  styleUrls: ['./report-status-cell.component.css']
})
export class ReportStatusCellComponent {
  @Input() status!: string;

  get statusClass(): string {
    switch (this.status?.toLowerCase()) {
      case ' completed':
        return 'status-completed';
      case ' not started':
        return 'status-not-started';
      case ' rejected':
        return 'status-rejected';
      case ' voided':
        return 'status-voided';
      case ' in progress':
        return 'status-in-progress';
      case ' discarded':
        return 'status-discarded';
    }
  }
}
